export default __webpack_public_path__ + "static/media/homebuyer-stay-on-top.1cd40f70.jpg";